import api from "../../client";
import {
  CreateLinkPayload,
  CreateLinkResponseData,
  LinkSectionEnum,
} from "../../types/link";

export const createProfileLinkRequest = async (
  section: LinkSectionEnum,
  uuid: string | undefined,
  payload: CreateLinkPayload,
): Promise<CreateLinkResponseData> => {
  const { data } = await api.post<CreateLinkResponseData>(
    `/${section}/${uuid}/link`,
    payload,
  );

  return data;
};
